var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDocumentDigitalization = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M17.2 6.9c-.6 0-1.2-.5-1.2-1.2V3.2c0-.4.3-.8.8-.8.4 0 .7.1 1 .4L20.5 5c.3.4.5.8.5 1.3 0 .4-.3.7-.7.7h-3.1zM17 3.5v2.3c0 .1.1.2.2.2H20l-.1-.1-2.7-2.2c-.1-.1-.1-.2-.2-.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDE0E8",
  d: "M13 10.8H8.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H13c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M22.3 13H5.7c-.3 0-.5-.2-.5-.5s.3-.5.5-.5h16.6c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#B4D8F9",
  d: "M19.5 20.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#61DAFF",
  d: "M19.1 21.7H8.2c-1.1 0-1.9-.9-1.9-2v-5.6h1v5.6c0 .5.4 1 .9 1H19c.5 0 .9-.4.9-1v-5.5h1v5.5c.1 1.1-.7 2-1.8 2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#61DAFF",
  d: "M16.5 17H8.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.8c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M7.3 10.8h-1V4.4c0-1.1.9-2 1.9-2h6.4v4.1c0 .9.7 1.6 1.5 1.6H21v2.5h-1V9.2h-3.8c-1.4 0-2.5-1.1-2.5-2.6V3.5H8.2c-.5 0-.9.4-.9 1z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M6.7 23.5c-1.1 0-2.1-.9-2.1-2.1V5.8c0-.8.4-1.4 1-1.8.2-.1.5-.1.7.2.1.2.1.5-.2.7-.3.1-.5.5-.5.9v15.7c0 .6.5 1.1 1.1 1.1h11.8c.4 0 .6-.1.8-.5.1-.3.4-.4.7-.3s.4.4.3.7c-.3.8-.9 1.1-1.7 1.1H6.7zM9.4 19.9v-1z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#61DAFF",
  d: "M17.6 18.1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5m0-2.1c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5c0-.2-.2-.5-.5-.5"
})));
export default SvgDocumentDigitalization;